import { LandscapeModule } from '../objects/LandscapeModule';
import { ProductModule } from '../objects/ProductModule';
import { RoomWall } from '../objects/RoomWall';
import { ProjectRenderer } from '../ProjectRenderer';
import { Mouse } from '../input/Mouse';
import { Group, Vector2 } from 'three';
import { DraggableObject } from '../objects/DraggableObject';

export class MouseDragHandler {
	draggedObject: DraggableObject | null = null;
	draggedProductModules: ProductModule[] = [];
	draggingGroup = new Group();

	constructor(private renderer: ProjectRenderer, private mouse: Mouse) {
		this.renderer.room.add(this.draggingGroup);
	}

	handleGroupDragging() {
		this.draggingGroup.position.set(...this.mouse.scenePos.toArray());
	}

	handleDragging() {
		if (!this.draggedObject) return;

		const delta = this.mouse.scenePos.clone().sub(this.mouse.mouseDownScenePos);

		if (this.draggedObject instanceof RoomWall) {
			const isCorrect = this.renderer.roomManager.handleWallDrag(
				this.draggedObject,
				new Vector2(delta.x, delta.z)
			);

			if (isCorrect) this.mouse.mouseDownScenePos.copy(this.mouse.scenePos);
			return;
		}

		if (this.draggedObject instanceof LandscapeModule) {
			const correctedPos = this.mouse.scenePos
				.clone()
				.sub(this.mouse.dragOffset);
			this.renderer.modulesManager.handleLandscapeModuleDragging(
				this.draggedObject,
				correctedPos
			);
		}

		if (this.draggedObject instanceof ProductModule) {
			this.renderer.modulesManager.handleProductModuleDragging(
				this.draggedObject,
				this.mouse.scenePos.clone()
			);
			return;
		}
	}

	handleRoomDrag() {
		const delta = this.mouse.scenePos.clone().sub(this.mouse.mouseDownScenePos);

		this.renderer.roomManager.handleRoomDrag(new Vector2(delta.x, delta.z));
		this.mouse.mouseDownScenePos.copy(this.mouse.scenePos);
	}

	handleRoomDragEnd() {
		this.renderer.roomManager.handleRoomDragEnd();
	}

	clearDraggingGroup() {
		for (const productModule of this.draggedProductModules) {
			if (productModule.group.parent === this.draggingGroup)
				this.renderer.room.attach(productModule.group);
		}

		this.draggingGroup.clear();
		this.draggingGroup.position.set(0, 0, 0);
		this.draggedProductModules = [];
	}

	cancelActiveDrag() {
		if (this.draggedObject) {
			this.draggedObject.isDragging = false;
			this.draggedObject = null;
			this.renderer.cameraController.perspectiveControls.enableRotate = true;
		}

		this.clearDraggingGroup();
	}
}
